<header class="page-header"><a id="logo-link" class="header-logo" href="/"><img
	id="logo" style="display: inline; padding-left: 5px;" tabindex="0"
	src="{{ logoUrl }}" alt="Return to {{chainName}} Homepage"></a></header>
